import BaseProductImportManagerStore from './BaseProductImportManagerStore'

export default BaseProductImportManagerStore
